import { ActionsAdapter } from "./adapters/actionsAdapter";
import { Glob } from "./glob";

export type ActionScope = {
	check(adapter: ActionsAdapter): boolean;
}

export class All implements ActionScope {
	scopes: ActionScope[];

	constructor(scopes: ActionScope[]) {
		this.scopes = scopes;
	}

	check(adapter: ActionsAdapter): boolean {
		if(this.scopes.length == 0)
			return false;

		for(const scope of this.scopes) {
			if(!scope.check(adapter))
				return false;
		}

		return true;
	}
}

export class Any implements ActionScope {
	scopes: ActionScope[];

	constructor(scopes: ActionScope[]) {
		this.scopes = scopes;
	}

	check(adapter: ActionsAdapter): boolean {
		if(this.scopes.length == 0)
			return false;

		for(const scope of this.scopes) {
			if(scope.check(adapter))
				return true;
		}

		return false;
	}
}

export class Action implements ActionScope {
	action: string;

	constructor(action: string) {
		this.action = action;
	}

	check(adapter: ActionsAdapter): boolean {
		return adapter.isAllowed(this);
	}
}

export class Pattern implements ActionScope {
	pattern: Glob;

	constructor(pattern: string) {
		this.pattern = new Glob(pattern);
	}

	check(adapter: ActionsAdapter): boolean {
		return adapter.hasCongruency(this);
	}
}

export class ActionOrPattern extends Any {
	constructor(actionOrPattern: string) {
		super([
			new Action(actionOrPattern),
			new Pattern(actionOrPattern)
		]);
	}
}
